import { CommonModule, CurrencyPipe, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSortModule } from '@angular/material/sort';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { IpTableComponent } from '../../components/ip-table/ip-table.component';
import { FnFiltersModalComponent } from './components/fn-filters-modal/fn-filters-modal.component';
import { IpSearchInputComponent } from '../../components/ip-search-input/ip-search-input.component';

@NgModule({
  declarations: [
    FnFiltersModalComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule,
    MatIconModule,
    MatNativeDateModule,
    TranslateModule,
    MatSortModule,
    MatCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    IpTableComponent,
    IpSearchInputComponent,
  ],
  providers: [
    TranslateService,
    SharedModule,
    TranslateModule,
    DatePipe,
    CurrencyPipe,
  ],
})
export class FinanceModule {}
